import React from 'react';

export const LigningIcon = () => {

    return (
        <svg width="40" height="40" viewBox="0 0 40 40" style={{ filter: 'drop-shadow(0 0 7px #F2C94C)'}} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.4505 17.0872V17.4652H19.8285H27.2548C24.6808 21.0576 22.5114 25.4413 21.3169 29.4661H20.5488V22.7569V22.3789H20.1708H12.7451C15.3186 18.7865 17.4886 14.4028 18.6831 10.378H19.4505V17.0872Z" fill="#F2C94C" stroke="#E8D394" strokeWidth="0.755965"/>
        </svg>
        
    )
}